import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveSingle } from "../../services/yardService";
import { getAll } from "../../services/visaService";
import Select from "../common/select";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class YardForm extends Form {
  state = {
    expiryDate: new Date(),
    data: {
      visa_id: "",
      name: "",
      mobile: "",
      rent: "",
      emirates_id: "",
    },
    visas: [],
    errors: {},
  };

  schema = {
    id: Joi.string(),
    visa_id: Joi.number().allow("").label("Visa Account"),
    name: Joi.string().allow("").label("Name"),
    mobile: Joi.string().allow("").label("Mobile"),
    rent: Joi.number().required().label("Rent"),
    emirates_id: Joi.allow("").label("Emirates Id"),
  };

  handleChangeExpiry = (date) => {
    this.setState({
      expiryDate: date,
    });
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    const { data: visasAccounts } = await getAll();
    const visas = [{ id: "", name: "Select" }, ...visasAccounts];

    this.setState({ visas, blocking: false });
  }

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });

      let formData = new FormData();
      if (this.state.data.room_number == undefined) {
        this.state.data.room_number = "";
      }
      formData.append("visa_id", this.state.data.room_number);
      formData.append("name", this.state.data.name);
      formData.append("mobile", this.state.data.mobile);
      formData.append("rent", this.state.data.rent);
      formData.append("emirates_id", this.state.data.emirates_id);

      var event = new Date(this.state.expiryDate);
      let date = JSON.stringify(event);
      date = date.slice(1, 11);
      formData.append("expiry_date", date);

      await saveSingle(formData);
      toast.success("Account has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/yards-accounts");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.visa_id)
          errors.visa_id = ex.response.data.errors.visa_id;

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.mobile)
          errors.mobile = ex.response.data.errors.mobile;

        if (ex.response.data.errors.rent)
          errors.rent = ex.response.data.errors.rent;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/yard.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add yard account</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/yards-accounts")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add yard account</h3>
              <p>Provide the information below to add the account.</p>
              {this.renderSelect(
                "visa_id",
                "Select visa account (optional)",
                this.state.visas
              )}

              {this.renderInput("name", "Name", "text")}
              {this.renderInput("mobile", "Mobile", "text")}
              {this.renderInput("rent", "Rent", "text")}
              <label>Renewal Date</label>

              <DatePicker
                selected={this.state.expiryDate}
                onChange={this.handleChangeExpiry}
                className="input"
              />
              {this.renderInput("emirates_id", "Emirates Id", "text")}
              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default YardForm;
